<template>
  <v-skeleton-loader
    :loading="isLoading"
    transition="expand-transition"
    type="article"
  >
    <FormUserPin
      :UserPin="editUserPin"
      :isSaving="isSaving"
      @save="save"
      @cancel="$router.push({name: from.name })" />
  </v-skeleton-loader>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import FormUserPin from '../components/FormUserPin.vue';

export default {
  components: {
    FormUserPin,
  },
  name: 'EditUserPin',
  module: 'UserPin',
  mixins: [loading],
  data() {
    return {
      /**
      * Get/Set editing UserPin. Default to {}.
      */
      editUserPin: {},
      /**
       * Query Id for UserPin
       */
      userPinId: this.$route?.query.id,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('userPins', ['userPins', 'userPin']),
    /** Get the mode for this view, create or update
     */
    mode() {
      if (this.userPinId) {
        return 'edit';
      }
      return 'add';
    },
  },
  async mounted() {
    this.isLoading = true;
    if (this.mode === 'edit') {
      await this.LOAD_userPin(this.userPinId);
      this.editUserPin = this.userPin;
    }
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('userPins', ['LOAD_userPin', 'CREATE_userPin', 'UPDATE_userPin']),
    /** Method used to save the item
     */
    async save(userPin) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_userPin(userPin);
      } else {
        await this.UPDATE_userPin(userPin);
      }
      this.isSaving = false;
      this.$router.push({ name: 'processing-ListUserPin' });
    },
  },
};
</script>

<docs>
# EditUserPin example

'''js
<EditUserPin :UserPin="UserPin" />
'''
</docs>
